import { Field, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import AnnexASievingWashConstantDryMassMultiTraySection from './AnnexASievingWashConstantDryMassSectionMultiTray';
import AnnexASievingWashConstantDryMassSingleTraySection from './AnnexASievingWashConstantDryMassSingleTraySection';

let AnnexASievingWashFinePortionSubspecimenWashingSection: React.FC<IWorksheetComponent> = ({
  createWorksheetSelector,
}) => {
  const singleTray = useSelector(
    pipe(createWorksheetSelector!('Masses.MeasuredWashedConstantDryMass.DryingTrays'), (p) => !p || p.length < 2)
  );

  return (
    <>
      <ListFieldSection>
        <Field input={<TextOutput />} name="Masses.InitialDryMass" label="Initial Fine Portion Subspecimen Dry Mass" />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="oven"
          name="Masses.MeasuredWashedConstantDryMass.Equipment.Oven"
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="sieve"
          name="Equipment.WashingSieve"
          label="Wash Sieve"
          queryParams={{ SieveSize: '63 μm' }}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="sieve"
          name="Equipment.GuardSieve"
          queryParams={{ SieveSize: '1.00 mm:4.75 mm' }}
        />
      </ListFieldSection>

      <NamePrefixModifier appendNamePrefix={'Masses.MeasuredWashedConstantDryMass'}>
        {singleTray ? (
          <AnnexASievingWashConstantDryMassSingleTraySection addTrayButtonVissible />
        ) : (
          <AnnexASievingWashConstantDryMassMultiTraySection />
        )}
      </NamePrefixModifier>

      <ListFieldSection>
        <Field input={<TextOutput />} name="Masses.WashedDryMass" label="Portion Washed Dry Mass" />
        <Field input={<TextOutput />} name="Masses.WashingsDryMass" />
      </ListFieldSection>
    </>
  );
};

AnnexASievingWashFinePortionSubspecimenWashingSection = withInjectedProps(
  AnnexASievingWashFinePortionSubspecimenWashingSection
);

export default AnnexASievingWashFinePortionSubspecimenWashingSection;
export { AnnexASievingWashFinePortionSubspecimenWashingSection as AnnexAFinePortionSubspecimenWashingSection };
